import useParentOneLayout from './parentOne/useParentOneLayout';
import useParentTwoLayout from './parentTwo/useParentTwoLayout';
import useChildLayout from './child/useChildLayout';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import useIsTreeHierarchyEnabled from '../../../../../state/filters/hooks/useIsTreeHierarchyEnabled';
import { ProjectProgressionFiltersContext } from '../../../../../state/filters/contexts';

const mapLayoutByLevel = {
  0: useChildLayout,
  1: useParentOneLayout,
  2: useParentTwoLayout
};

const useTableLayout = ({ data, tableType }) => {
  const pmProvider = useSelector(pmToolSensorIdSelector);
  const isTreeHierarchyEnabled = useIsTreeHierarchyEnabled(
    ProjectProgressionFiltersContext
  );
  const useLayout = mapLayoutByLevel[tableType.level];
  const tableLayout = useLayout({ data, pmProvider, isTreeHierarchyEnabled });

  return tableLayout;
};

export default useTableLayout;
